import { shopRepository } from './adapters/api/shop.api'
import { videoRepository } from './adapters/api/video.api'
import { livesRepository } from './adapters/api/lives.api'
import { adsRepository } from './adapters/api/ads.api'
import { authRepository } from './adapters/api/auth.api'
import { creatorRepository } from './adapters/api/creators.api'
import { contentRepository } from './adapters/mock/content.mock'
import { samplesRepository } from './adapters/mock/samples.mock'
import { scorecardsRepository } from './adapters/api/scorecards.api'
import { createApiLaunchRepository } from './adapters/api/launch.api'
import { createApiLaunchTemplateRepository } from './adapters/api/launch-template.api'
import { createApiPlanDefaultRepository } from './adapters/api/plan-default.api'
import { createApiLaunchProjectionRepository } from './adapters/api/launch-projection.api'
import { createApiPlanCustomLineRepository } from './adapters/api/plan-custom-line.api'
import { createApiScorecardReviewRepository } from './adapters/api/scorecard-review.api'
import { createApiFeatureAccessRepository } from './adapters/api/feature-access.api'
import { createApiAgencyOverviewRepository } from './adapters/api/agency-overview.api'
import { createApiShareLinkRepository } from './adapters/api/share-link.api'
import { blueprintRepository } from './adapters/api/blueprint.api'
import { signalRepository } from './adapters/api/signal.api'

import { calendarRepository } from './adapters/api/calendar.api'
import { createApiFreshnessRepository } from './adapters/api/freshness.api'
import { oauthApi } from './adapters/api/oauth.api'
import { apiKeysApi } from './adapters/api/api-keys.api'

export const repositories = {
  shop: shopRepository,
  video: videoRepository,
  lives: livesRepository,
  ads: adsRepository,
  auth: authRepository,
  creators: creatorRepository,
  content: contentRepository,
  samples: samplesRepository,
  scorecards: scorecardsRepository,
  scorecardReview: createApiScorecardReviewRepository(),
  launch: createApiLaunchRepository(),
  launchTemplate: createApiLaunchTemplateRepository(),
  planDefault: createApiPlanDefaultRepository(),
  launchProjection: createApiLaunchProjectionRepository(),
  planCustomLines: createApiPlanCustomLineRepository(),
  featureAccess: createApiFeatureAccessRepository(),
  agencyOverview: createApiAgencyOverviewRepository(),
  shareLink: createApiShareLinkRepository(),
  blueprint: blueprintRepository,
  signal: signalRepository,

  calendar: calendarRepository,
  freshness: createApiFreshnessRepository(),
  oauth: oauthApi,
  apiKeys: apiKeysApi,
}
